import { Box, Stack } from "@chakra-ui/react";
import React, { Fragment } from "react";
import GravityFormsField from ".";

const NameField = ({
  label,
  placeholder,
  isRequired,
  labelPlacement,
  id: fieldId,
  inputs,
}) => {
  return (
    <Stack direction={{ base: "column", lg: "row" }} spacing={8}>
      {inputs.map(({ label, id, inputType, isHidden }) => (
        <Fragment key={id}>
          {!isHidden && (
            <Box flex="1">
              <GravityFormsField
                field={{
                  label: label,
                  id: id.replace(".", "_"),
                  type: inputType ? inputType : "TEXT",
                  isRequired: isRequired,
                }}
              />
            </Box>
          )}
        </Fragment>
      ))}
    </Stack>
  );
};

export default NameField;
